import { render } from "./Collateral.vue?vue&type=template&id=717d0fb9"
import script from "./Collateral.vue?vue&type=script&lang=js"
export * from "./Collateral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__